module.exports = __webpack_public_path__ + "static/media/logo_for_app_surplusV1.fa480b3d.jpg";